import React from "react";

/* Card */
const Card = React.forwardRef(({ className, style, ...props }, ref) => (
  <div
    ref={ref}
    style={{
      borderRadius: "12px",
      border: "1px solid #e2e8f0",
      backgroundColor: "#ffffff",
      color: "#0f172a",
      boxShadow: "0 1px 2px rgba(0,0,0,0.06)",
      ...style
    }}
    {...props}
  />
));
Card.displayName = "Card";

/* CardHeader */
const CardHeader = React.forwardRef(({ style, ...props }, ref) => (
  <div
    ref={ref}
    style={{
      display: "flex",
      flexDirection: "column",
      gap: "6px",
      padding: "24px",
      ...style
    }}
    {...props}
  />
));
CardHeader.displayName = "CardHeader";

/* CardTitle */
const CardTitle = React.forwardRef(({ style, ...props }, ref) => (
  <h3
    ref={ref}
    style={{
      fontSize: "20px",
      fontWeight: 600,
      lineHeight: "1.2",
      letterSpacing: "-0.02em",
      color: "#0f172a",
      margin: 0,
      ...style
    }}
    {...props}
  />
));
CardTitle.displayName = "CardTitle";

/* CardDescription */
const CardDescription = React.forwardRef(({ style, ...props }, ref) => (
  <p
    ref={ref}
    style={{
      fontSize: "14px",
      color: "#64748b",
      margin: 0,
      ...style
    }}
    {...props}
  />
));
CardDescription.displayName = "CardDescription";

/* CardContent */
const CardContent = React.forwardRef(({ style, ...props }, ref) => (
  <div
    ref={ref}
    style={{
      padding: "24px",
      paddingTop: "0",
      ...style
    }}
    {...props}
  />
));
CardContent.displayName = "CardContent";

/* CardFooter */
const CardFooter = React.forwardRef(({ style, ...props }, ref) => (
  <div
    ref={ref}
    style={{
      display: "flex",
      alignItems: "center",
      padding: "24px",
      paddingTop: "0",
      ...style
    }}
    {...props}
  />
));
CardFooter.displayName = "CardFooter";

export {
  Card,
  CardHeader,
  CardFooter,
  CardTitle,
  CardDescription,
  CardContent
};
